import { render, staticRenderFns } from "./ShippingConverter.vue?vue&type=template&id=0e548f2a&scoped=true&"
import script from "./ShippingConverter.vue?vue&type=script&lang=js&"
export * from "./ShippingConverter.vue?vue&type=script&lang=js&"
import style0 from "./ShippingConverter.vue?vue&type=style&index=0&id=0e548f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e548f2a",
  null
  
)

export default component.exports